import { render, staticRenderFns } from "./TenantManagementView.vue?vue&type=template&id=1928bde2"
import script from "./TenantManagementView.vue?vue&type=script&lang=js"
export * from "./TenantManagementView.vue?vue&type=script&lang=js"
import style0 from "./TenantManagementView.vue?vue&type=style&index=0&id=1928bde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports